import React, {useEffect, useState} from "react";
import PageHeader from "../../components/organisms/PageHeader";
import request from "../../config/Axios";
import List from "../../components/organisms/List";

const Campaign = () => {
    const [row, setRow] = useState([]);
    const navList = [
        {
            name: "공지",
            link: "/notice/announcement"
        },
        {
            name: "캠페인",
            link: "/notice/campaign"
        },
        {
            name: "강아지숲 이야기",
            link: "/notice/dstory"
        },
        {
            name: "자주하는 질문",
            link: "/notice/faq"
        },
    ];
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    useEffect( () => {
        (async ()=>{
            try {
            const campaignResponse = await request.get(`boards/campaign/posts`,{
                params: {
                    page: page
                }
            });
                setRow(campaignResponse.data.data.postList);
                setTotalPages(campaignResponse.data.data.totalPages);
            } catch (err) {
                console.error('api 호출 중 에러 발생:', err);
            }
        })();
    }, [page]);
    return (
        <>
            <PageHeader
                bTitle="알림"
                detail="캠페인"
                desc="강아지숲의 캠페인을 안내해 드립니다."
                list={navList}
                top={true}
            />
            <List
                row={row}
                columns={3}
                category={"캠페인"}
                totalPages={totalPages}
                page={page}
                changePage={setPage}
            />
        </>
    );
};

export default Campaign;
